import { useRouter } from 'next/router'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { NotFoundError } from 'utils/customError'

import type { KinerjaApp } from 'types/kinerja-layout'

const Page: KinerjaApp = () => {
  const router = useRouter()
  throw new NotFoundError(router.asPath, new Error('Not found'))
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
}

export default Page
